import React, { useCallback, useContext, useRef } from "react"
import SKLand from "@skland/one-bridge"
import classNames from "classnames"
import { SafeAreaView } from "@hg/layouts"
import { useRoleLogout, useShowRoleSelect } from "@hg/one-account"

import { auth } from "@/utils/auth"
import { adapter, webLogin } from "@/utils/sdk"
import { GlobalContext } from "../../context"

import styles from "./index.module.less"

const isBilibili = adapter.source.from === "bilibili"

const UserComponentTW: React.FC<{
    className?: string
    style?: React.CSSProperties
}> = ({ className, style }) => {
    const {
        state: { user },
        dispatch,
    } = useContext(GlobalContext)

    const roleLogout = useRoleLogout()
    const handleLogout = useCallback(async () => {
        await roleLogout({ withAccount: true })
        auth.clearToken()
        dispatch({
            type: "updateContext",
            payload: {
                user: null,
            },
        })
    }, [dispatch, roleLogout])

    return (
        <div
            className={classNames(styles.userComponentTW, className)}
            style={style}
        >
            <div className={styles.name}>{user?.nickName || user?.uid}</div>
            <svg
                className={styles.logout}
                viewBox="0 0 68.76 69.56"
                onClick={handleLogout}
            >
                <g strokeMiterlimit={10} strokeWidth="8px">
                    <polyline
                        fill="none"
                        stroke="currentColor"
                        points="44.86 65.56 4 65.56 4 4 44.86 4"
                    />
                    <rect
                        fill="currentColor"
                        x="19.51"
                        y="29.28"
                        width="41.25"
                        height="10.86"
                    />
                    <polygon
                        fill="currentColor"
                        points="68.76 34.71 44.86 17.68 44.86 51.74 68.76 34.71"
                    />
                </g>
            </svg>
        </div>
    )
}

interface IProps {
    className?: string
}

const Menu: React.FC<IProps> = (props) => {
    const { className } = props

    const {
        state: { bgm, hasRole },
        dispatch,
    } = useContext(GlobalContext)

    const showRoleSelect = useShowRoleSelect()

    const handleClickLogin = useCallback(async () => {
        if (!user) {
            await webLogin(dispatch)
        } else {
            dispatch({
                type: "updateContext",
                payload: {
                    showRegistry: true,
                },
            })
        }
    }, [dispatch, hasRole, showRoleSelect])

    const handleClickHome = useCallback(() => {
        window.open("https://arknights.kr/", "_blank")
    }, [])

    const handleClickMusic = useCallback(() => {
        dispatch({
            type: "updateContext",
            payload: { bgm: !bgm },
        })
    }, [dispatch, bgm])

    const containerRef = useRef<HTMLDivElement>(null)

    const {
        state: { user },
    } = useContext(GlobalContext)

    return (
        <SafeAreaView
            ref={containerRef}
            mode="margin"
            edges={["right"]}
            className={classNames(styles.menu, className)}
        >
            {__LOCALE === "zh-tw" && user ? (
                <UserComponentTW />
            ) : (
                <div
                    className={classNames(styles.menuItem, styles.login)}
                    onClick={(e) => {
                        e.stopPropagation()
                        handleClickLogin()
                    }}
                />
            )}
            <div
                className={classNames(styles.menuItem, styles.home)}
                onClick={(e) => {
                    e.stopPropagation()
                    handleClickHome()
                }}
            />
            <div
                className={classNames(
                    styles.menuItem,
                    styles.bgm,
                    !bgm && styles.off
                )}
                onClick={(e) => {
                    e.stopPropagation()
                    handleClickMusic()
                }}
            />
        </SafeAreaView>
    )
}

export default Menu
